/**
 * Swipe Class
 */

define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var _ = require('underscore');
    var Class = require('Class');
    var mathAlgorithms = require('util/math.util').algorithms;
    var Backbone = require('backbone');
    var device = require('util/device.util');

    var _id = 0,
        $body = $('body');

    var Swipe = Class.create(Backbone.Events, {

        detecting: false,
        currentAnimationFrame: null,

        initialize: function($el, options) {
            options = options || {};

            this.id = _id++;
            this.$el = $el;
            this.el = $el[0];
            this.position = {
                x: 0,
                y: 0
            };

            this.detectingStrategy = options.detectingStrategy || Swipe.detectingStrategies.x;

            if (device.isTouchDevice) {
                this.$el.on('touchstart.swipe' + this.id, this.start.bind(this));
            } else {
                this.$el.on('mousedown.swipe' + this.id, this.start.bind(this));
            }

            Swipe.swipeInstances.push(this);
        },

        start: function(e) {
            var touch = e.changedTouches ? e.changedTouches[0] : e;

            if (e.target.tagName === 'SELECT' ||
                e.target.tagName === 'INPUT' || e.touches && e.touches.length !== 1 || this.started) {
                this.started = false;
                return this.undelegateEvents();
            }

            this.detecting = true;
            this.x = touch.pageX;
            this.y = touch.pageY;
            this.$startTarget = $(touch.target);

            if (device.isTouchDevice) {
                // add listener for touchend in not swiping case
                this.$startTarget.on('touchend.swipe-init' + this.id, this.end.bind(this));

                $body.on('touchmove.swipe' + this.id, this.move.bind(this));
                $body.on('touchcancel.swipe' + this.id, this.end.bind(this));
                $body.on('touchend.swipe' + this.id, this.end.bind(this));
            } else {
                $body.on('mousemove.swipe' + this.id, this.move.bind(this));
                $body.on('mouseup.swipe' + this.id, this.end.bind(this));
                $body.on('mouseleave.swipe' + this.id, this.end.bind(this));
            }

            return this;
        },

        move: function(e) {
            var generalDirection = {},
                touch,
                touchPageX,
                touchPageY;

            var isConflict = Boolean(_.find(Swipe.swipeInstances, function(swipe) {
                return swipe !== this && swipe.started;
            }, this)) || Swipe._isDetectingStopped;

            if (isConflict) {
                return this.undelegateEvents();
            }

            if (e.touches && e.touches.length !== 1 || !this.started && !this.detecting) {
                return;
            }

            touch = e.changedTouches ? e.changedTouches[0] : e;
            touchPageX = touch.pageX || 0;
            touchPageY = touch.pageY || 0;

            if (this.detecting) {
                if (this.detectingStrategy(this, touch)) {
                    e.preventDefault();

                    this.x = touchPageX;
                    this.y = touchPageY;
                    this.start = {
                        x: this.position.x,
                        y: this.position.y
                    };
                    this.started = true;
                    this.stopAnimation();
                    this.trigger('start', this);

                    this.detecting = false;
                }
            }

            if (this.started) {
                generalDirection = {
                    y: (this.delta ? this.delta.y : 0) - (this.y - touchPageY) >= 0 ? -1 : 1,
                    x: (this.delta ? this.delta.x : 0) - (this.x - touchPageX) >= 0 ? -1 : 1
                };
                this.delta = {
                    y: this.y - touchPageY,
                    x: this.x - touchPageX
                };
                this.direction = {
                    y: generalDirection.y > 0 !== this.delta.y > 0 ? 0 : generalDirection.y,
                    x: generalDirection.x > 0 !== this.delta.x > 0 ? 0 : generalDirection.x
                };
                this.e = e;
                this.trigger('move', this);

                e.preventDefault();
            }

            return this;
        },

        translate: function(x, y, type) {
            type = type || 'px';
            this.position.x = x || 0;
            this.position.y = y || 0;
            this.$el.css({
                '-webkit-transform': 'translate3d(' + x + type + ', ' + y + type + ', 0)',
                '-moz-transform': 'translate3d(' + x + type + ', ' + y + type + ', 0)',
                'msTransform': 'translate(' + x + type + ', ' + y + type + ')',
                '-ms-transform': 'translate3d(' + x + type + ', ' + y + type + ', 0)',
                'transform': 'translate3d(' + x + type + ', ' + y + type + ', 0)'
            });

            return this;
        },

        getTransformValues: function() {
            var st = window.getComputedStyle(this.el),
                props = st.getPropertyValue('transform') ||
                    st.getPropertyValue('-webkit-transform') ||
                    st.getPropertyValue('-moz-transform') ||
                    st.getPropertyValue('msTransform') ||
                    st.getPropertyValue('-ms-transform');
            return props.replace('matrix(', '').replace(')', '').split(', ');
        },

        end: function(e) {
            this.undelegateEvents();

            if (!this.started) {
                return;
            }

            e && e.cancelable && e.preventDefault();

            if (this.started) {
                this.trigger('end', this);
            }

            this.started = false;
            this.detecting = true;

            if (e) {
                $(e.target).on('tap.swipe-click-fix click.swipe-click-fix', function(event) {
                    event.stopPropagation();
                });

                setTimeout(function() {
                    $(e.target).off('.swipe-click-fix');
                });
            }

            return this;
        },

        undelegateEvents: function() {
            // remove temporary listener from init target
            this.$startTarget && this.$startTarget.off('.swipe-init' + this.id);

            $body.off('.swipe' + this.id);

            return this;
        },

        destroy: function() {
            this.off();
            this.undelegateEvents();
            this.stopAnimation();
            this.$el.off('.swipe' + this.id);

            Swipe.swipeInstances.splice(Swipe.swipeInstances.indexOf(this), 1);
        },

        animateTo: function(toX, toY, duration, easingFunction, callback, type) {
            easingFunction = easingFunction || mathAlgorithms.easeInOutCubic;

            var start = Date.now();
            var ended = false;
            var position = this.position;
            var fromX = position.x;
            var fromY = position.y;

            var checkEnd = function() {
                if (ended === false && position.x === toX && position.y === toY) {
                    ended = true;

                    if (callback) {
                        callback.call(this, this);
                    }

                    return true;
                }
            }.bind(this);

            this.stopAnimation();

            if (checkEnd()) {
                return;
            }

            var scroll = function(coord, from, to) {
                var currentTime = Date.now(),
                    time = _.min([1, (currentTime - start) / duration]),
                    easedT = easingFunction(time);

                if (coord === 'x') {
                    this.translate(easedT * (to - from) + from, position.y, type);
                } else if (coord === 'y') {
                    this.translate(position.x, easedT * (to - from) + from, type);
                }

                if (time < 1) {
                    this.currentAnimationFrame = window.requestAnimationFrame(function() {
                        scroll(coord, from, to);
                    });
                } else {
                    checkEnd();
                }
            }.bind(this);

            fromX !== toX && window.requestAnimationFrame(function() {
                scroll('x', fromX, toX);
            });
            fromY !== toY && window.requestAnimationFrame(function() {
                scroll('y', fromY, toY);
            });

            return this;
        },

        stopAnimation: function() {
            window.cancelAnimationFrame(this.currentAnimationFrame);

            return this;
        }

    });

    /**
     * End all started move actions for Swipe instances
     */
    Swipe.endMoving = function() {
        Swipe.swipeInstances.forEach(function(swipe) {
            swipe.direction = {
                x: 0,
                y: 0
            };
            swipe.end();
        });
    };

    /**
     * Disable all detection events if true
     * @type {Boolean}
     */
    Swipe._isDetectingStopped = false;

    /**
     * Disable all detection events
     */
    Swipe.stopDetecting = function() {
        Swipe._isDetectingStopped = true;
    };

    /**
     * Enable all detection events
     */
    Swipe.startDetecting = function() {
        Swipe._isDetectingStopped = false;
    };

    Swipe.swipeInstances = [];

    Swipe.detectingStrategies = {
        x: function(swipe, touch) {
            return Math.abs(this.x - touch.pageX) > Math.abs(this.y - touch.pageY);
        },
        y: function(swipe, touch) {
            return Math.abs(this.y - touch.pageY) > Math.abs(this.x - touch.pageX);
        }
    };

    module.exports = Swipe;
});
